"use client"

import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { CancelButton } from "@src/components/Button"
import Icons from "@src/components/Icons"
import { useTranslation } from "react-i18next"

const PaymentItem = ({ onClose }) => {
  const { t } = useTranslation("home-policy")

  return (
    <Box position="relative">
      <Typography variant="body1" lineHeight="24px">
        {t("payment.intro")}
      </Typography>
      <Typography
        sx={{
          display: "list-item",
          marginLeft: "20px"
        }}
        variant="body1"
        lineHeight="24px"
      >
        {t("payment.cod")}
      </Typography>
      <Typography
        sx={{
          display: "list-item",
          marginLeft: "20px"
        }}
        variant="body1"
        lineHeight="24px"
      >
        {t("payment.online")}
      </Typography>
      <CancelButton
        type="button"
        height="40px"
        label={t("collapse")}
        endIcon={<Icons name="arrow-up" />}
        minHeight="40px"
        minWidth="160px"
        sx={{
          margin: {
            xs: "24px auto 0",
            md: "48px auto 0"
          }
        }}
        onClick={onClose}
      />
    </Box>
  )
}

export default PaymentItem
